import {} from 'react';
import { Account, useGetMyAccountsQuery } from '~/graphql/types';

type Options = {
  skip?: boolean;
};

const useAccounts = (
  options?: Options,
): Array<Omit<Account, 'Users' | 'Mailboxes'>> => {
  const { data, loading, error } = useGetMyAccountsQuery({
    skip: options?.skip,
  });

  if (loading || error || !data || !data.getMyAccounts) return [];

  return data.getMyAccounts || [];
};

export default useAccounts;
